/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
    ApiResult,
    TaskInfoAddRequest,
    TaskInfoDto,
} from "../models/index";
import {
    ApiResultFromJSON,
    ApiResultToJSON,
    TaskInfoAddRequestFromJSON,
    TaskInfoAddRequestToJSON,
    TaskInfoDtoFromJSON,
    TaskInfoDtoToJSON,
} from "../models/index";

export interface TaskDetailRequest {
    taskInfoId: string;
}

export interface TaskInfoAddOperationRequest {
    body?: TaskInfoAddRequest;
}

export interface TaskListRequest {
    userAccountId?: number;
    limit?: number;
    olderThan?: Date;
}

export interface TaskListForDeviceRequest {
    deviceIdentity: string;
    limit?: number;
    olderThan?: Date;
}

/**
 *
 */
export class TasksHttpFunctionsApi extends runtime.BaseAPI {
    /**
     * Task details
     */
    async taskDetailRaw(
        requestParameters: TaskDetailRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<TaskInfoDto>> {
        if (requestParameters["taskInfoId"] == null) {
            throw new runtime.RequiredError(
                "taskInfoId",
                'Required parameter "taskInfoId" was null or undefined when calling taskDetail().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/tasks/{taskInfoId}`.replace(
                    `{${"taskInfoId"}}`,
                    encodeURIComponent(String(requestParameters["taskInfoId"])),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            TaskInfoDtoFromJSON(jsonValue),
        );
    }

    /**
     * Task details
     */
    async taskDetail(
        requestParameters: TaskDetailRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<TaskInfoDto> {
        const response = await this.taskDetailRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Add a task to issue a command to a device. Updates will be published to the calling user\'s SignalR onTaskInfoUpdateMessage method
     */
    async taskInfoAddRaw(
        requestParameters: TaskInfoAddOperationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/tasks`,
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: TaskInfoAddRequestToJSON(requestParameters["body"]),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Add a task to issue a command to a device. Updates will be published to the calling user\'s SignalR onTaskInfoUpdateMessage method
     */
    async taskInfoAdd(
        requestParameters: TaskInfoAddOperationRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.taskInfoAddRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * List all tasks (if permitted), or all tasks created by the current IlluminateUser. Supports paging
     */
    async taskListRaw(
        requestParameters: TaskListRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<TaskInfoDto>>> {
        const queryParameters: any = {};

        if (requestParameters["userAccountId"] != null) {
            queryParameters["userAccountId"] =
                requestParameters["userAccountId"];
        }

        if (requestParameters["limit"] != null) {
            queryParameters["limit"] = requestParameters["limit"];
        }

        if (requestParameters["olderThan"] != null) {
            queryParameters["olderThan"] = (
                requestParameters["olderThan"] as any
            ).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/tasks`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(TaskInfoDtoFromJSON),
        );
    }

    /**
     * List all tasks (if permitted), or all tasks created by the current IlluminateUser. Supports paging
     */
    async taskList(
        requestParameters: TaskListRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<TaskInfoDto>> {
        const response = await this.taskListRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * List all tasks (if you have Permission.device_tasks_read), or all tasks created by the current IlluminateUser, for the supplied deviceIdentity. Supports paging
     */
    async taskListForDeviceRaw(
        requestParameters: TaskListForDeviceRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<TaskInfoDto>>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling taskListForDevice().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["limit"] != null) {
            queryParameters["limit"] = requestParameters["limit"];
        }

        if (requestParameters["olderThan"] != null) {
            queryParameters["olderThan"] = (
                requestParameters["olderThan"] as any
            ).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/tasks/devices/{deviceIdentity}`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(TaskInfoDtoFromJSON),
        );
    }

    /**
     * List all tasks (if you have Permission.device_tasks_read), or all tasks created by the current IlluminateUser, for the supplied deviceIdentity. Supports paging
     */
    async taskListForDevice(
        requestParameters: TaskListForDeviceRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<TaskInfoDto>> {
        const response = await this.taskListForDeviceRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }
}
